// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_FiscalConfigListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /subaccounts/invoices/fiscal_config/list
 * (routed to subaccounts/invoice_config/fiscal_config_list).
 *
 * One row per franchise the caller has permission on, with is_configured
 * pre-computed so the table can render badges without N round-trips.
 */
import type { Invoice_FiscalConfigListRow } from './Invoice_FiscalConfigListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_FiscalConfigListResponseDados {
rows: Invoice_FiscalConfigListRow[]
}

export type Invoice_FiscalConfigListResponse = ApiResponse<Invoice_FiscalConfigListResponseDados>;

registerResponseContract('Invoice_FiscalConfigListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      franchise_id:     { type: 'number',  required: true },
      franchise_name:   { type: 'string',  required: false },
      country:          { type: 'string',  required: false },
      invoice_provider: { type: 'string',  required: false },
      is_configured:    { type: 'boolean', required: false },
    },
  },
})
